if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        
        // Store selected addons data (will be updated by product-addons component)
        this.selectedAddons = [];
        this.selectedAddonVariants = new Map(); // For product-level addons
      }

      // Method for product-addons to update selected addons
      updateSelectedAddons(addonsData) {
        this.selectedAddons = addonsData || [];
      }

      // Method for product-addons to update selected variant for a product-level addon
      updateAddonVariant(productId, variantId) {
        if (variantId) {
          this.selectedAddonVariants.set(productId, variantId);
        } else {
          this.selectedAddonVariants.delete(productId);
        }
      }


      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Validate required custom variant selects
        // Search from the product section to find custom variant selects
        const productSection = this.closest('[data-section]') || this.closest('.product') || this.closest('section');
        const requiredSelects = productSection ? 
          productSection.querySelectorAll('.custom-variant-select[data-required="true"]') : 
          document.querySelectorAll('.custom-variant-select[data-required="true"]');
        
        for (const selectFieldset of requiredSelects) {
          const hiddenInput = selectFieldset.querySelector('input[data-custom-variant-input="true"]');
          if (!hiddenInput) continue;
          
          const checkedRadio = selectFieldset.querySelector('input[type="radio"]:checked');
          const hiddenValue = (hiddenInput.value || '').trim();
          
          // Validation: Must have a checked radio AND a non-empty value
          // If no radio is checked OR value is empty, show error
          const isValid = checkedRadio && hiddenValue && hiddenValue !== '';
          
          // Find or create error element for this select
          const errorElement = selectFieldset.querySelector('.custom-variant-select__error');
          const errorMessageElement = errorElement ? errorElement.querySelector('.custom-variant-select__error-message') : null;
          
          if (!isValid) {
            const selectLabel = selectFieldset.getAttribute('data-select-label') || 'option';
            const errorMessage = `Please choose a ${selectLabel}`;
            
            // Show error below the select field
            if (errorElement && errorMessageElement) {
              errorMessageElement.textContent = errorMessage;
              errorElement.style.display = 'block';
              // Scroll to error element
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              // Fallback to product-form error if element not found
              this.handleErrorMessage(errorMessage);
            }
            this.submitButton.removeAttribute("aria-disabled");
            return;
          }
          
          // Also check if the value matches placeholder text (indicates default/placeholder state)
          const placeholderText = hiddenInput.getAttribute('data-placeholder-text');
          if (placeholderText && hiddenValue === placeholderText.trim()) {
            const selectLabel = selectFieldset.getAttribute('data-select-label') || 'option';
            const errorMessage = `Please choose a ${selectLabel}`;
            
            // Show error below the select field
            if (errorElement && errorMessageElement) {
              errorMessageElement.textContent = errorMessage;
              errorElement.style.display = 'block';
              // Scroll to error element
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              // Fallback to product-form error if element not found
              this.handleErrorMessage(errorMessage);
            }
            this.submitButton.removeAttribute("aria-disabled");
            return;
          }
          
          // Hide error if validation passes
          if (errorElement) {
            errorElement.style.display = 'none';
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        //For product card
        const selectedOption = this.closest(".card")?.querySelector(
          ".js-cart-option input:checked"
        );
        if (selectedOption) {
          selectedOption.nextElementSibling.classList.add("loading");
          selectedOption.nextElementSibling
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");

          this.closest(".card--product")
            .querySelectorAll(".js-cart-option input")
            .forEach((input) => {
              if (input != selectedOption) {
                input.classList.add("disabled-loading");
              }
            });
        }

        // Check if fetchConfig is available
        if (typeof fetchConfig === 'undefined') {
          this.handleErrorMessage("Unable to add product to cart. Please refresh the page and try again.");
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
          return;
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const parentVariantId = this.querySelector("[name=id]").value;
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        // Ensure special instructions textarea is included if it exists
        const specialInstructionsTextarea = productSection 
          ? productSection.querySelector('textarea[name="properties[Special Instructions]"]')
          : document.querySelector('textarea[name="properties[Special Instructions]"]');
        if (specialInstructionsTextarea && specialInstructionsTextarea.value.trim()) {
          formData.set("properties[Special Instructions]", specialInstructionsTextarea.value.trim());
        }

        // Add upload locations to cart properties if available
        if (typeof window.addLocationsToCartProperties === 'function') {
          window.addLocationsToCartProperties(formData);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (!window.routes?.cart_add_url) {
          this.handleErrorMessage("Unable to add product to cart. Please refresh the page and try again.");
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
          return;
        }

        const cartAddUrl = this.addUrlHandler(window.routes.cart_add_url);
        if (!cartAddUrl || cartAddUrl === 'undefined' || cartAddUrl === 'null') {
          this.handleErrorMessage("Unable to add product to cart. Please refresh the page and try again.");
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
          return;

        }
        
        const addOns = this.selectedAddons;
        const formDataEntries = Object.fromEntries(formData);
        const addOnsData = addOns.map(addon => {
          return {
            parent_id: parentVariantId,
            variant_id: addon.variantId,
            quantity: addon.quantity
          }
        })

        const id = formData.get('id');
        let quantity = formData.get('quantity');
        
        console.log('[ProductForm] Initial quantity from formData:', quantity);
        
        // If no quantity provided, check if this is a quantity tier product and default appropriately
        if (!quantity || quantity === '' || quantity === null) {
          console.log('[ProductForm] Quantity not found in formData, searching DOM...');
          // Check for quantity tier input in the product section
          const productSection = this.closest('[data-section]') || this.closest('.product') || this.closest('section');
          const qtyTierInput = productSection?.querySelector('input[data-quantity-tier="true"]');
          if (qtyTierInput) {
            // For quantity tier products, use the input value or default to 25
            quantity = qtyTierInput.value || '25';
            console.log('[ProductForm] Found quantity tier input, value:', quantity);
          } else {
            // Check if any quantity input exists that we might have missed
            const anyQtyInput = productSection?.querySelector('input[name="quantity"]');
            if (anyQtyInput) {
              quantity = anyQtyInput.value || '1';
              console.log('[ProductForm] Found regular quantity input, value:', quantity);
            } else {
              // Default to 1 for regular products
              quantity = '1';
              console.log('[ProductForm] No quantity input found, defaulting to 1');
            }
          }
        }
        
        console.log('[ProductForm] Final quantity being submitted:', quantity);
        
        const section = formData.get('section-id');
        
        const mainProductProperties = {};
        const stripQuotes = (v) => String(v ?? "").replace(/['"’“”′″]/g, "").trim();
        const isDimensionProp = (name) =>
          /^(Width|Height)\s*\((Feet|Inches)\)$/i.test(name) ||
          /^(WIDTH|HEIGHT)$/i.test(name);

        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[") && value != null && value !== "") {
            const propName = key.replace("properties[", "").replace("]", "");

            // ✅ Only sanitize Width/Height-related fields
            const cleanedValue = isDimensionProp(propName) ? stripQuotes(value) : value;

            mainProductProperties[propName] = cleanedValue;
          }
        }

        // Add _bundle_id to main product properties
        mainProductProperties['_bundle_id'] = id;
        
        // Build addon properties - include _is_discount_applicable if main product has it
        const addonProperties = {
          "_bundle_id": id,
          "_parent_key": "",
        };
        if (mainProductProperties['_is_discount_applicable']) {
          addonProperties['_is_discount_applicable'] = mainProductProperties['_is_discount_applicable'];
        }

        const body = {
          "items": [
            {
              "id": id,
              "quantity": quantity,
              "properties": mainProductProperties
            },
            ...addOnsData.map(addon => {
              return {
                "id": addon.variant_id,
                "quantity": quantity,
                "parent_id": id,
                "properties": addonProperties
              }
            })
          ]
        }

        fetch(`${cartAddUrl}?sections=${section}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
          .then((response) => {
            if (!response.ok) {
              // Try to get error message from response
              return response.text().then(text => {
                try {
                  const json = JSON.parse(text);
                  return { ...json, status: response.status, ok: false };
                } catch {
                  return { 
                    status: response.status,
                    ok: false, 
                    message: text || `HTTP ${response.status}: ${response.statusText}`,
                    description: text || `HTTP ${response.status}: ${response.statusText}`
                  };
                }
              });
            }
            return response.json();
          })
          .then((response) => {
            if (response && response.items && response.items.length > 0 && addOnsData.length > 0) {
              const mainItem = response.items.find(item => !item.properties || !item.properties['_parent_key']);
              if (mainItem && mainItem.key) {
                const mainItemKey = mainItem.key;
                const addonItems = response.items
                  .filter(item => item.properties && item.properties.hasOwnProperty('_parent_key'))
                  .map(item => ({ key: item.key, quantity: item.quantity }));
                
                if (addonItems.length > 0) {
                  const updatedAddonProperties = {
                    '_bundle_id': id,
                    '_parent_key': mainItemKey
                  };
                  if (mainProductProperties['_is_discount_applicable']) {
                    updatedAddonProperties['_is_discount_applicable'] = mainProductProperties['_is_discount_applicable'];
                  }

                  const updatePromises = addonItems.map(addon => {
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        id: addon.key,
                        quantity: addon.quantity,
                        properties: updatedAddonProperties
                      })
                    });
                  });
                  
                  Promise.all(updatePromises).catch(err => {
                    console.warn('Failed to update addon _parent_key:', err);
                  });
                }
              }
            }
            return response;
          })
          .then((response) => {
            const parentProductCard = this.closest(".card--product");
            if (parentProductCard) {
              [".card__error", ".card__error--no-options"].forEach(
                (selector) => {
                  const el = parentProductCard.querySelector(selector);
                  if (el) el.innerText = "";
                }
              );
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              //For product card
              if (parentProductCard) {
                //for color
                //this.submitButton.setAttribute("aria-disabled", true);
                //this.submitButton.setAttribute("disabled", "");
                //this.submitButton.setAttribute("title", window.variantStrings.soldOut );

                //for other option
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("aria-disabled", true);
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("disabled", "");
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("title", window.variantStrings.soldOut);

                const hasOptionsModal =
                  parentProductCard.querySelector(".js-cart-option");
                const cardError =
                  parentProductCard.querySelector(".card__error");
                const cardErrorNoOptions = parentProductCard.querySelector(
                  ".card__error--no-options"
                );
                if (hasOptionsModal && cardError) {
                  cardError.innerText = response.message;
                }

                if (!hasOptionsModal && cardErrorNoOptions) {
                  cardErrorNoOptions.innerText = response.message;
                  cardErrorNoOptions.classList.add("active");
                  setTimeout(() => {
                    cardErrorNoOptions.classList.remove("active");
                  }, 5000);
                }

                this.error = true;
                return;
              }

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              // Show notification instead of redirecting
              // Handle addons and notification asynchronously
              this.handleAddonsAndNotification(response,parentVariantId);
              // Don't redirect - just show notification and stay on page
              return;
            }

            if (!this.error) {
              // Add addons if any are selected (handle this asynchronously)
              this.handleAddonsAndNotification(response,parentVariantId);
            }
            this.error = false;
            
            // Ensure response has sections before rendering
            if (!response || !response.sections) {
              // Try to fetch cart drawer manually
              if (this.cart && window.routes?.cart_url) {
                fetch(`${window.routes.cart_url}?section_id=cart-drawer&section_id=cart-icon-bubble`)
                  .then(res => res.text())
                  .then(text => {
                    const html = new DOMParser().parseFromString(text, "text/html");
                    const cartDrawerSection = html.querySelector('#cart-drawer, [data-section-type="cart-drawer"]');
                    const cartIconSection = html.querySelector('#cart-icon-bubble, [data-section-type="cart-icon-bubble"]');
                    if (cartDrawerSection || cartIconSection) {
                      const mockResponse = {
                        sections: {}
                      };
                      if (cartDrawerSection) {
                        mockResponse.sections['cart-drawer'] = cartDrawerSection.outerHTML;
                      }
                      if (cartIconSection) {
                        mockResponse.sections['cart-icon-bubble'] = cartIconSection.outerHTML;
                      }
                      this.cart.renderContents(mockResponse);
                    }
                  })
                  .catch(() => {});
              }
              return;
            }
            
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    if (this.cart) {
                      this.cart.renderContents(response);
                    }
                  }, 100);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart) {
                this.cart.renderContents(response);
              }
            }
          })
          .catch(() => {
            this.handleErrorMessage("Unable to add product to cart. Please try again.");
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: "Network error",
              message: "Unable to add product to cart. Please try again.",
            });
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            //For product card
            if (this.closest(".card--product")) {
              this.submitButton.removeAttribute("aria-disabled");
            }
            if (selectedOption) {
              selectedOption.nextElementSibling.classList.remove("loading");
              selectedOption.nextElementSibling
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");

              if (!this.error) {
                selectedOption
                  .closest(".js-cart-option")
                  .classList.remove("active");
                const quickAddBtn = selectedOption
                  .closest(".card--product")
                  .querySelector(".card__link--add-to-cart_show");
                if (quickAddBtn) quickAddBtn.style.opacity = 1;
                const quickViewBtn = selectedOption
                  .closest(".card--product")
                  .querySelector(".card__quick-view_mobile");
                if (quickViewBtn) quickViewBtn.style.opacity = 1;
              }

              this.closest(".card--product")
                .querySelectorAll(".js-cart-option input")
                .forEach((input) => {
                  input.classList.remove("disabled-loading");
                  input.checked = false;
                });
            }
            window.location.href = "/cart";
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      addUrlHandler(url) {
        if (url === "/cart/add") {
          return "/cart/add.js";
        }

        return url;
      }

      async handleAddonsAndNotification(response,parentVariantId) {
        const addonData = [];
        
        // Add addons if any are selected
        if (this.selectedAddons && this.selectedAddons.length > 0) {
          // Get quantity from form
          const qtyInput = this.form?.querySelector('input[name="quantity"]');
          const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          
          // Add each addon sequentially
          for (const addon of this.selectedAddons) {
            const variantId = addon.variantId || this.selectedAddonVariants.get(addon.productId) || addon.id;
            if (variantId) {
              // const success = await this.addAddonToCart(variantId, quantity, parentVariantId);
              if (true) {
                addonData.push({
                  id: addon.id,
                  productTitle: addon.productTitle,
                  variantTitle: addon.variantTitle,
                  image: addon.image
                });
              }
              // Small delay between adds
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
          
          // Update cart drawer after all addons are added
          if (this.cart && window.routes?.cart_url) {
            await new Promise(resolve => setTimeout(resolve, 300));
            fetch(`${window.routes.cart_url}?section_id=cart-drawer&section_id=cart-icon-bubble`)
              .then(res => res.text())
              .then(text => {
                const html = new DOMParser().parseFromString(text, "text/html");
                const cartDrawerSection = html.querySelector('#cart-drawer, [data-section-type="cart-drawer"]');
                const cartIconSection = html.querySelector('#cart-icon-bubble, [data-section-type="cart-icon-bubble"]');
                if (cartDrawerSection || cartIconSection) {
                  const mockResponse = {
                    sections: {}
                  };
                  if (cartDrawerSection) {
                    mockResponse.sections['cart-drawer'] = cartDrawerSection.outerHTML;
                  }
                  if (cartIconSection) {
                    mockResponse.sections['cart-icon-bubble'] = cartIconSection.outerHTML;
                  }
                  this.cart.renderContents(mockResponse);
                }
              })
              .catch(() => {});
          }
        }
        
        // Clear upload locations after successful cart add
        if (typeof window.clearUploadLocations === 'function') {
          window.clearUploadLocations();
        }

        // Show notification with addons
        this.showCartNotification(response, addonData);
        
        // Clear selected addons after successful addition
        this.selectedAddons = [];
        this.selectedAddonVariants.clear();
        
        // Publish cart update event AFTER all operations complete
        // Use a delay to ensure everything is done
        setTimeout(() => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: this.form?.querySelector('[name="id"]')?.value,
          });
          
          // Also dispatch custom event and call reset function directly as backup
          const productSection = this.closest('[data-section]') || this.closest('.product') || this.closest('section');
          if (productSection) {
            const productAddonsElement = productSection.querySelector('product-addons');
            if (productAddonsElement) {
              // Dispatch custom event
              productAddonsElement.dispatchEvent(new CustomEvent('reset-addons'));
              // Also call reset function directly if available
              if (typeof productAddonsElement.resetAddons === 'function') {
                setTimeout(() => {
                  productAddonsElement.resetAddons();
                }, 100);
              }
            }
          }
        }, 600);
      }

      showCartNotification(response, addonData = []) {
        // Wait a bit for cart to update
        setTimeout(() => {
          if (typeof window.showCartNotification !== 'function') {
            return;
          }

          // Get product information
          const productInfo = this.getProductData();
          
          // Show notification with addons
          window.showCartNotification(productInfo, addonData);
        }, 500);
      }

      // Helper method to add addon to cart
      // async addAddonToCart(variantId, quantity = 1, parentId) {
      //   if (!window.routes?.cart_add_url) {
      //     return false;
      //   }
        
      //   const formData = new FormData();
      //   formData.append('id', variantId);
      //   formData.append('quantity', String(quantity));
      //   formData.append('parent_id', parentId);

      //   const cartAddUrl = window.routes.cart_add_url === '/cart/add' 
      //       ? '/cart/add.js' 
      //       : window.routes.cart_add_url;

      //   try {
      //     const response = await fetch(cartAddUrl, {
      //       method: 'POST',
      //       body: formData
      //     });
          
      //     const responseText = await response.text();
          
      //     if (response.ok) {
      //       try {
      //         JSON.parse(responseText);
      //         return true;
      //       } catch (jsonError) {
      //         return false;
      //       }
      //     } else {
      //       return false;
      //     }
      //   } catch (error) {
      //     return false;
      //   }
      // }

      getProductData() {
        const productSection = this.closest('[data-section]') || this.closest('.product') || this.closest('section');
        
        // Get product name
        let productName = '';
        const productTitle = productSection?.querySelector('.product__title, h1.product__title');
        if (productTitle) {
          productName = productTitle.textContent.trim();
        } else {
          // Fallback: try to get from product form data
          const productForm = this.form || this;
          const productHandle = productForm.dataset.productHandle;
          if (productHandle) {
            productName = productHandle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
          }
        }

        // Get product image
        let productImage = '';
        const productImageEl = productSection?.querySelector('.product__media img, .product__media-wrapper img, [data-product-image] img');
        if (productImageEl) {
          productImage = productImageEl.src || productImageEl.dataset.src;
        }

        return {
          name: productName || 'Product',
          image: productImage
        };
      }

    }
  );
}
